export default __webpack_public_path__ + "static/media/shopifyNativeConcent3.178fb826.svg";